var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1265",
    "data-name": "Grupo 1265",
    transform: "translate(-20 -700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_374",
    "data-name": "Ret\\xE2ngulo 374",
    transform: "translate(20 700)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1458",
    "data-name": "Grupo 1458",
    transform: "translate(20 702.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder_check_2_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M98.4-771.382a14.1,14.1,0,0,0,.153,2.095,13.032,13.032,0,0,0,.46,1.993H84.088a3.937,3.937,0,0,1-2.887-1.2,3.936,3.936,0,0,1-1.2-2.887v-24.53a3.937,3.937,0,0,1,1.2-2.887,3.937,3.937,0,0,1,2.887-1.2H96.353l4.088,4.088h16.353a3.937,3.937,0,0,1,2.887,1.2,3.937,3.937,0,0,1,1.2,2.887v8.739A13.834,13.834,0,0,0,117-785.027a14.12,14.12,0,0,0-4.293-.664,13.787,13.787,0,0,0-10.118,4.191A13.787,13.787,0,0,0,98.4-771.382Z",
    transform: "translate(-80 800)",
    fill: "#22638d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_2",
    "data-name": "Subtra\\xE7\\xE3o 2",
    d: "M0,7.219v4.812H10.046L6.2,15.881,9.625,19.25,19.25,9.625,9.625,0,6.256,3.429l3.79,3.79Z",
    transform: "translate(24.75 19.853)",
    fill: "#22638d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveItem);
export default __webpack_public_path__ + "static/media/moveItem.38b56b325d0b90651c92d64edfd5cb75.svg";
export { ForwardRef as ReactComponent };